const protocols = {
	FTP: "ftp",
	SFTP: "sftp",
	S3_CLIPSOURCE: "s3_clipsource",
	BOKBASEN_API: "bokbasen_api",
};

export default protocols;
